import { formatFinnishCurrencyWithSymbol } from '@ui-common/utils'

interface InvestmentReturnForTimePeriods {
  valueFor3Years: string
  valueFor10Years: string
  valueForLongestLoan: string
  savingsForLongestLoan: string
  profitForLongestLoan: string
}

export const LOAN_OFFER_SAVINGS_MAX_MONTHLY_VALUE = 100_000
export const LOAN_OFFER_SAVINGS_ANNUAL_INTEREST_RATE = 0.035

export const getInvestmentReturns = (
  monthlySaving: number | undefined,
  longestLoanTimeMonths: number,
): InvestmentReturnForTimePeriods | undefined => {
  if (!monthlySaving || monthlySaving < 1) {
    return undefined
  }
  const threeYearsInMonths = 36
  const tenYearsInMonths = 120

  const valuesFor3Years = calculateInvestmentReturn(monthlySaving, threeYearsInMonths)
  const valuesFor10Years = calculateInvestmentReturn(monthlySaving, tenYearsInMonths)
  const valuesForLongestLoan = calculateInvestmentReturn(monthlySaving, longestLoanTimeMonths)

  return {
    valueFor3Years: formatFinnishCurrencyWithSymbol(valuesFor3Years.futureValue),
    valueFor10Years: formatFinnishCurrencyWithSymbol(valuesFor10Years.futureValue),
    valueForLongestLoan: formatFinnishCurrencyWithSymbol(valuesForLongestLoan.futureValue),
    savingsForLongestLoan: formatFinnishCurrencyWithSymbol(valuesForLongestLoan.totalInvested),
    profitForLongestLoan: formatFinnishCurrencyWithSymbol(valuesForLongestLoan.interestEarned),
  }
}

const calculateInvestmentReturn = (monthlySaving: number, savingTimeInMonths: number) => {
  const effectiveInterest = Math.pow(1 + 0.035, 1 / 12) - 1

  const unroundedFutureValue =
    monthlySaving *
    ((Math.pow(1 + effectiveInterest, savingTimeInMonths) - 1) / effectiveInterest) *
    (1 + effectiveInterest)

  const futureValue = Math.round(unroundedFutureValue)
  const totalInvested = monthlySaving * savingTimeInMonths
  const interestEarned = futureValue - totalInvested

  return {
    futureValue,
    totalInvested,
    interestEarned,
  }
}
